import React from "react";
import { Col, Row } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/viewPostModal.module.scss";
import ImageWithPlaceholder from "../CustomComponents/ImageWithPlaceholder";

const ViewUserDetails = ({ handleViewModalClose, data }) => {
  console.log(data);

  return (
    <div>
      <ModalContainer handleClose={handleViewModalClose}>
        <div className={cssStyles.modalContainer} style={{ maxWidth: "75%" }}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-semibold m-0 black-text">View Details</p>
            <span className="bg-white bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleViewModalClose}
                style={{ cursor: "pointer", color: "black" }}
              />
            </span>
          </div>

          <Row className="w-100 h-100">
            <Col md={12} sm={12} className="">
              <div className="d-flex flex-column justify-content-start align-items-top w-100 h-100">
                <UserProfile data={data} />
              </div>
            </Col>
          </Row>
        </div>
      </ModalContainer>
    </div>
  );
};

export default ViewUserDetails;

const UserProfile = ({ data }) => {
  const {
    badge_no,
    blood_type,
    allergy_medicines,
    current_medications,
    dispatcher,
    dob,
    email,
    emergency_contact_no,
    heart_rate,
    height,
    id,
    image_url,
    latitude,
    location,
    longitude,
    mobile_no,
    name,
    officer_is_fine,
    phone_country_code,
    show_motion,
    show_perspiration,
    show_temperature,
    slug,
    user_type,
    weight,
  } = data;

  return (
    <div className={cssStyles.userProfileContainer}>
      <div className={`w-100 d-flex gap-3 text-black`}>
        <ImageWithPlaceholder
          src={image_url}
          placeholder={"/images/user-placeholder.jpeg"}
          alt="post"
          className="rounded-circle"
          height={62}
          width={62}
        />
        <div>
        <h4 className="text-capitalize fw-semibold">{name || "-"}</h4>
        <p>{user_type || "-"}</p>
        </div>
      </div>

      {/* <h3>Dispatcher Information</h3>
      {dispatcher && (
        <div className={cssStyles.dispatcherInfo}>
          <ImageWithPlaceholder
            src={dispatcher.image_url}
            placeholder={"/images/user-placeholder.jpeg"}
            alt="post"
            className="rounded-circle"
            height={50}
            width={50}
          />
          <p>{dispatcher.name || "-"}</p>
          <p>{dispatcher.email || "-"}</p>
        </div>
      )} */}
      <div className={cssStyles.profileDetails}>
        <Row className="w-100">
        <Col md={6} sm={6} className="">
        <h3 className="fw-semibold">Basic Information</h3>
        <ul>
          <li>
            <strong>Badge Number:</strong> {badge_no || "-"}
          </li>
          <li>
            <strong>Blood Type:</strong> {blood_type || "-"}
          </li>
          <li>
            <strong>Date of Birth:</strong> {dob || "-"}
          </li>
          <li>
            <strong>Email:</strong> {email || "-"}
          </li>
          <li>
            <strong>Phone Number:</strong> {phone_country_code} {mobile_no || "-"}
          </li>
          <li>
            <strong>Emergency Contact:</strong> {emergency_contact_no || "-"}
          </li>
          <li>
            <strong>Heart Rate:</strong> {heart_rate || "-"} BMP
          </li>
          <li>
            <strong>Height:</strong> {height || "-"} Foot
          </li>
          <li>
            <strong>Weight:</strong> {weight || "-"} kg
          </li>
        </ul>

        <h3 className="fw-semibold">Current Medical Details</h3>
        <ul>
          <li>
            <strong>Allergy Medicines:</strong> {allergy_medicines || "-"}
          </li>
          <li>
            <strong>Current Medications:</strong> {current_medications || "-"}
          </li>
        </ul>
        </Col>
        <Col md={6} sm={6} className="">
        <h3 className="fw-semibold">Location Details</h3>
        <ul>
          <li>
            <strong>Latitude:</strong> {latitude || "-"}
          </li>
          <li>
            <strong>Longitude:</strong> {longitude || "-"}
          </li>
          <li>
            <strong>Location:</strong> {location || "-"}
          </li>
        </ul>

        <h3 className="fw-semibold">Other Information</h3>
        <ul>
          <li>
            <strong>Officer Status:</strong>{" "}
            {officer_is_fine === 1 ? "Fine" : "Not Fine"}
          </li>
          <li>
            <strong>Motion Display:</strong>{" "}
            {show_motion ? "Enabled" : "Disabled"}
          </li>
          <li>
            <strong>Perspiration Display:</strong>{" "}
            {show_perspiration ? "Enabled" : "Disabled"}
          </li>
          <li>
            <strong>Temperature Display:</strong>{" "}
            {show_temperature ? "Enabled" : "Disabled"}
          </li>
        </ul>
        </Col>
        </Row>
      </div>
    </div>
  );
};
